/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../models/users';
import '../../../common/currency';
import '../../../common/time';
import './request';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "CashDrawerShiftEvent": {
                        "fields": {
                          "clientEventToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "employee": {
                            "type": ".squareup.beemo.api.v2.models.Employee",
                            "id": 2,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "eventType": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShiftEvent.Type",
                            "id": 4,
                            "rule": "optional"
                          },
                          "eventMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "occurredAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "NO_SALE": 1,
                              "CASH_TENDER_PAYMENT": 2,
                              "OTHER_TENDER_PAYMENT": 3,
                              "CASH_TENDER_CANCELLED_PAYMENT": 4,
                              "OTHER_TENDER_CANCELLED_PAYMENT": 5,
                              "CASH_TENDER_REFUND": 6,
                              "OTHER_TENDER_REFUND": 7,
                              "PAID_IN": 8,
                              "PAID_OUT": 9,
                              "CHECK_BALANCE": 10
                            }
                          }
                        }
                      },
                      "CashDrawerShift": {
                        "fields": {
                          "merchant": {
                            "type": ".squareup.beemo.api.v2.models.Merchant",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clientCashDrawerShiftToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShift.State",
                            "id": 3,
                            "rule": "optional"
                          },
                          "employee": {
                            "type": ".squareup.beemo.api.v2.models.Employee",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "description": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "openingEmployee": {
                            "type": ".squareup.beemo.api.v2.models.Employee",
                            "id": 6,
                            "rule": "optional"
                          },
                          "endingEmployee": {
                            "type": ".squareup.beemo.api.v2.models.Employee",
                            "id": 7,
                            "rule": "optional"
                          },
                          "closingEmployee": {
                            "type": ".squareup.beemo.api.v2.models.Employee",
                            "id": 8,
                            "rule": "optional"
                          },
                          "openedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 9,
                            "rule": "optional"
                          },
                          "endedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 10,
                            "rule": "optional"
                          },
                          "closedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 11,
                            "rule": "optional"
                          },
                          "startingCashMoney": {
                            "type": ".squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "cashPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "cashRefundsMoney": {
                            "type": ".squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "cashPaidInMoney": {
                            "type": ".squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "cashPaidOutMoney": {
                            "type": ".squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "expectedCashMoney": {
                            "type": ".squareup.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "closedCashMoney": {
                            "type": ".squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "event": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShiftEvent",
                            "id": 19,
                            "rule": "repeated"
                          },
                          "device": {
                            "type": ".squareup.beemo.api.v2.models.Device",
                            "id": 20,
                            "rule": "optional"
                          },
                          "endedDevice": {
                            "type": ".squareup.beemo.api.v2.models.Device",
                            "id": 21,
                            "rule": "optional"
                          },
                          "closedDevice": {
                            "type": ".squareup.beemo.api.v2.models.Device",
                            "id": 22,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "State": {
                            "values": {
                              "OPEN": 1,
                              "ENDED": 2,
                              "CLOSED": 3
                            }
                          }
                        }
                      },
                      "CashDrawerShiftsReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "selectedClientCashDrawerShiftUuid": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CashDrawerShiftsReportResponse": {
                        "fields": {
                          "cashDrawerShift": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShift",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ListCashDrawerShiftsRequest": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "intervalParams": {
                            "type": ".squareup.beemo.api.v2.reporting.ListCashDrawerShiftsRequest.DateTimeIntervalParams",
                            "id": 2,
                            "rule": "optional"
                          },
                          "includeState": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShift.State",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "includeEvents": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "selectedClientCashDrawerShiftUuid": {
                            "type": "string",
                            "id": 5,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "DateTimeIntervalParams": {
                            "fields": {
                              "openedAtInterval": {
                                "type": ".squareup.common.time.DateTimeInterval",
                                "id": 1,
                                "rule": "optional"
                              },
                              "endedAtInterval": {
                                "type": ".squareup.common.time.DateTimeInterval",
                                "id": 2,
                                "rule": "optional"
                              },
                              "closedAtInterval": {
                                "type": ".squareup.common.time.DateTimeInterval",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ListCashDrawerShiftsResponse": {
                        "fields": {
                          "cashDrawerShift": {
                            "type": ".squareup.beemo.api.v2.reporting.CashDrawerShift",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShiftEvent && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShiftEvent?.nested?.Type && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShift && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShift?.nested?.State && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShiftsReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CashDrawerShiftsReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListCashDrawerShiftsRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListCashDrawerShiftsRequest?.nested?.DateTimeIntervalParams && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListCashDrawerShiftsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CashDrawerShiftEvent @ squareup/beemo/v2/reporting/cash_drawers.proto at 10:1
 */
export const CashDrawerShiftEvent = $root.lookupType('squareup.beemo.api.v2.reporting.CashDrawerShiftEvent');
fixType(CashDrawerShiftEvent);
Builder.createAndAttachToType(CashDrawerShiftEvent);
/**
 * SOURCE Type @ squareup/beemo/v2/reporting/cash_drawers.proto at 11:3
 */
CashDrawerShiftEvent.Type = $root.lookupEnum('squareup.beemo.api.v2.reporting.CashDrawerShiftEvent.Type').values;
/**
 * SOURCE CashDrawerShift @ squareup/beemo/v2/reporting/cash_drawers.proto at 41:1
 */
export const CashDrawerShift = $root.lookupType('squareup.beemo.api.v2.reporting.CashDrawerShift');
fixType(CashDrawerShift);
Builder.createAndAttachToType(CashDrawerShift);
/**
 * SOURCE State @ squareup/beemo/v2/reporting/cash_drawers.proto at 42:3
 */
CashDrawerShift.State = $root.lookupEnum('squareup.beemo.api.v2.reporting.CashDrawerShift.State').values;
/**
 * SOURCE CashDrawerShiftsReportRequest @ squareup/beemo/v2/reporting/cash_drawers.proto at 102:1
 */
export const CashDrawerShiftsReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.CashDrawerShiftsReportRequest');
fixType(CashDrawerShiftsReportRequest);
Builder.createAndAttachToType(CashDrawerShiftsReportRequest);
/**
 * SOURCE CashDrawerShiftsReportResponse @ squareup/beemo/v2/reporting/cash_drawers.proto at 107:1
 */
export const CashDrawerShiftsReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.CashDrawerShiftsReportResponse');
fixType(CashDrawerShiftsReportResponse);
Builder.createAndAttachToType(CashDrawerShiftsReportResponse);
/**
 * SOURCE ListCashDrawerShiftsRequest @ squareup/beemo/v2/reporting/cash_drawers.proto at 111:1
 */
export const ListCashDrawerShiftsRequest = $root.lookupType('squareup.beemo.api.v2.reporting.ListCashDrawerShiftsRequest');
fixType(ListCashDrawerShiftsRequest);
Builder.createAndAttachToType(ListCashDrawerShiftsRequest);
/**
 * A message containing parameters to apply to the cash drawer shifts query.
 *
 * SOURCE DateTimeIntervalParams @ squareup/beemo/v2/reporting/cash_drawers.proto at 119:3
 */
ListCashDrawerShiftsRequest.DateTimeIntervalParams = $root.lookupType('squareup.beemo.api.v2.reporting.ListCashDrawerShiftsRequest.DateTimeIntervalParams');
fixType(ListCashDrawerShiftsRequest.DateTimeIntervalParams);
Builder.createAndAttachToType(ListCashDrawerShiftsRequest.DateTimeIntervalParams);
/**
 * SOURCE ListCashDrawerShiftsResponse @ squareup/beemo/v2/reporting/cash_drawers.proto at 140:1
 */
export const ListCashDrawerShiftsResponse = $root.lookupType('squareup.beemo.api.v2.reporting.ListCashDrawerShiftsResponse');
fixType(ListCashDrawerShiftsResponse);
Builder.createAndAttachToType(ListCashDrawerShiftsResponse);